import CONFIG from "@rentiohq/shared/dist/config/app.config";
import { subYears } from "date-fns";
import { ERentioFormField } from "../../components/components/Form";
import { getValue } from "../../redux/form/form.utils";
import { formatDate } from "../../utils/date.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getMappedNationalities } from "../../utils/location/location.utils";
import { EField } from "./schema.kyc.types";
var NOW = new Date();
var CONTACT_AGE_RANGE_MIN = subYears(NOW, CONFIG.CONTACT_AGE_RANGE.MIN);
var CONTACT_AGE_RANGE_MAX = subYears(NOW, CONFIG.CONTACT_AGE_RANGE.MAX);
export var getSchema = function (initialValues) {
    return function (defaultValues) {
        var _a;
        return ({
            required: [EField.Nationality, EField.DateOfBirth, EField.Address],
            properties: (_a = {},
                _a[EField.Nationality] = {
                    default: getValue(EField.Nationality, initialValues, defaultValues),
                    // @ts-ignore
                    options: getMappedNationalities(),
                },
                _a[EField.DateOfBirth] = {
                    default: getValue(EField.DateOfBirth, initialValues, defaultValues),
                },
                _a[EField.Address] = {
                    default: getValue(EField.Address, initialValues, defaultValues),
                },
                _a),
        });
    };
};
export var uiSchema = function (extraData) {
    var _a;
    return (_a = {
            "rentio:trackingKey": "kyc",
            "ui:field": ERentioFormField.Grid,
            grid: {
                row: [
                    {
                        col: {
                            width: [1, 1 / 2],
                            children: [EField.Nationality],
                        },
                    },
                    {
                        col: {
                            width: [1, 1 / 2],
                            children: [EField.DateOfBirth],
                        },
                    },
                    {
                        col: {
                            width: 1,
                            children: [EField.Address],
                        },
                    },
                ],
            }
        },
        _a[EField.Nationality] = {
            "ui:field": ERentioFormField.DropdownSelect,
            title: getLocalizedText("system.nationality"),
            placeholder: getLocalizedText("address.nationality.placeholder"),
        },
        _a[EField.DateOfBirth] = {
            "ui:field": ERentioFormField.Date,
            title: getLocalizedText("system.date_of_birth"),
            minDate: CONTACT_AGE_RANGE_MIN,
            minDateError: "date_picker.alert.too_old.description",
            maxDate: CONTACT_AGE_RANGE_MAX,
            maxDateError: "date_picker.alert.too_young.description",
            formatSummary: function (formData) { return formData && formatDate(formData); },
        },
        _a[EField.Address] = {
            "ui:field": ERentioFormField.Address,
            title: getLocalizedText("system.address"),
            placeholder: getLocalizedText("system.address"),
        },
        _a);
};
